var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "max-w-xl mx-auto mt-10" }, [
    _vm.shouldShowExtensionLink
      ? _c("div", { staticClass: "bg-white shadow sm:rounded-lg" }, [
          _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
            _c(
              "div",
              { staticClass: "sm:flex sm:items-start sm:justify-between" },
              [
                _vm._m(0),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "inline-flex rounded-md shadow-sm" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150",
                            attrs: { type: "button" },
                            on: { click: _vm.openDownload }
                          },
                          [_vm._v(" Add to chrome ")]
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ])
      : _vm._e(),
    !_vm.shouldShowExtensionLink
      ? _c("div", { staticClass: "bg-white shadow sm:rounded-lg" }, [
          _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
            _c(
              "div",
              { staticClass: "sm:flex sm:items-start sm:justify-between" },
              [
                _vm._m(1),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "inline-flex rounded-md shadow-sm" },
                      [
                        !_vm.store.hasJoinedWaitlist
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150",
                                attrs: { type: "button" },
                                on: { click: _vm.joinWaitlist }
                              },
                              [_vm._v(" Get invited ")]
                            )
                          : _vm._e(),
                        _vm.store.hasJoinedWaitlist
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150",
                                attrs: { type: "button" }
                              },
                              [_vm._v(" We will get back to you soon :) ")]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._m(2),
    _c("div", { staticClass: "bg-white shadow sm:rounded-lg mt-10" }, [
      _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
        _c(
          "h3",
          { staticClass: "text-lg leading-6 font-medium text-gray-900" },
          [_vm._v(" Not using chrome? ")]
        ),
        _c(
          "div",
          { staticClass: "mt-2 max-w-xl text-sm leading-5 text-gray-500" },
          [
            _c("p", [_vm._v(" Let us know which browser you are using. ")]),
            _vm.isSaved
              ? _c("p", { staticClass: "text-green-400" }, [
                  _vm._v(" Your request noted :) ")
                ])
              : _vm._e()
          ]
        ),
        !_vm.isSaved
          ? _c("div", { staticClass: "mt-5 sm:flex sm:items-center" }, [
              _c("div", { staticClass: "max-w-xs w-full" }, [
                _c(
                  "label",
                  { staticClass: "sr-only", attrs: { for: "email" } },
                  [_vm._v("Email")]
                ),
                _c("div", { staticClass: "relative rounded-md shadow-sm" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.browserPreference,
                        expression: "browserPreference"
                      }
                    ],
                    staticClass:
                      "form-input block w-full sm:text-sm sm:leading-5",
                    attrs: {
                      id: "text",
                      placeholder: "Mozilla firefox, Opera.."
                    },
                    domProps: { value: _vm.browserPreference },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.browserPreference = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _c(
                "span",
                {
                  staticClass:
                    "mt-3 inline-flex rounded-md shadow-sm sm:mt-0 sm:ml-3 sm:w-auto"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "w-full inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150 sm:w-auto sm:text-sm sm:leading-5",
                      attrs: { type: "button" },
                      on: { click: _vm.saveBrowserPreference }
                    },
                    [_vm._v(" Save ")]
                  )
                ]
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Download Chrome Extension ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Get invited ")
      ]),
      _c(
        "div",
        { staticClass: "mt-2 max-w-xl text-sm leading-5 text-gray-500" },
        [
          _c("p", [
            _vm._v(
              " We are releasing this feature in batches. Kindly click the button to be invited. "
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "bg-white overflow-hidden shadow rounded-lg mt-10" },
      [
        _c(
          "div",
          { staticClass: "border-b border-gray-200 px-4 py-5 sm:px-6" },
          [_c("h1", [_vm._v("How It works")])]
        ),
        _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
          _c(
            "div",
            {
              staticClass: "mt-2 mb-6 max-w-xl text-sm leading-5 text-gray-500"
            },
            [
              _vm._v(
                " With automation you can send messages using your WhatsApp number automatically! The extension will alert you every time there are abandoned carts waiting and with a click we will automatically message all of them. You don't have to lift a finger :) "
              )
            ]
          ),
          _c("iframe", {
            attrs: {
              width: "100%",
              height: "315",
              src: "https://www.youtube.com/embed/D1Orz8m_nGs",
              frameborder: "0",
              allow:
                "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
              allowfullscreen: ""
            }
          })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }